import React from 'react';
import { createContext } from 'react';

const DashboardContext = createContext();
 

export default DashboardContext;